import { useState, useEffect, useCallback } from 'react';
import { triggerSync } from '@/swRegistration';

/**
 * Hook per gestionar l'estat offline/online i la cua de sincronització
 */
export function useOffline() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);
  const [syncMessage, setSyncMessage] = useState(null);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      // Auto-sync when back online
      triggerSync();
    };
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Listen for SW messages
    const handleMessage = (event) => {
      if (!event.data) return;
      if (event.data.type === 'OFFLINE_QUEUE_UPDATED') {
        setPendingCount((prev) => prev + (event.data.count || 1));
      }
      if (event.data.type === 'OFFLINE_SYNC_COMPLETE') {
        setPendingCount(0);
        setSyncMessage(event.data.message);
        setTimeout(() => setSyncMessage(null), 4000);
      }
    };

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', handleMessage);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      if (navigator.serviceWorker) {
        navigator.serviceWorker.removeEventListener('message', handleMessage);
      }
    };
  }, []);

  const manualSync = useCallback(() => {
    triggerSync();
  }, []);

  return { isOffline, pendingCount, syncMessage, manualSync };
}
